var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-menu',{attrs:{"default-active":_vm.activeIndex,"active-text-color":"#409EFF","mode":"horizontal"},on:{"select":_vm.handleSelect}},_vm._l((_vm.arrfontList),function(item,index){return _c('el-menu-item',{key:item.value,attrs:{"disabled":item.disabled,"index":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }